import { ORDER_TYPES } from '@/config/constants';
import moment from 'moment';


export const state = {
  cartDisplay:            false,
  checkoutModalDisplay:   false,
  cartContent:            {},
  orderType:              null,
  restaurantId:           null,
  order:                  null,
  calculatedOrder:        null,
  userOrders:             [],
  orderUpdated:           false,
  discountCodeIsUpdating: false,
  discountErrors:         [],
  discountCode:           '',
};

export const getters = {
  showCart:               state => state.cartDisplay,
  showCheckoutModal:      state => state.checkoutModalDisplay,
  cart:                   state => state.cartContent,
  cartLength:             state => Object.keys(state.cartContent).length,
  cartOrderIsUpdated:     state => state.orderUpdated,
  orderType:              state => state.orderType || ORDER_TYPES.inStore,
  restaurantId:           state => state.restaurantId,
  terminalId:             state => state.terminalId,
  order:                  state => state.order,
  calculatedOrder:        state => state.calculatedOrder,
  orders:                 state => state.userOrders,
  discountCodeIsUpdating: state => state.discountCodeIsUpdating,
  discountErrors:         state => state.discountErrors,
  discountCode:           state => state.discountCode,
  taxCheckout:            state => (state.order ? Number(state.order.tax) : 0),
  taxCalc:                state =>
    (state.calculatedOrder ? Number(state.calculatedOrder.tax) : 0),

  discountCalc: state => (state.calculatedOrder ?
    Number(state.calculatedOrder.discountPrice) : 0),

  discount: state =>
    (state.order ? Number(state.order.discountPrice) : 0),
  hasAppliedDiscount: (_, getters) => (getters.order ?
    (getters.order.promotionCodeApplied && getters.discount > 0) : false),

  orderTimes: (state) => {
    if (!state.order) {
      return [];
    }

    const entries = state.order.availablePickupTimes.map((pickupTime) => {
      const formattedTime = moment.parseZone(pickupTime);

      return [ formattedTime.format('hh:mm a'), formattedTime ];
    });

    return Object.fromEntries(entries);
  },
  /** @type {import('../../../store').VuexGetter<boolean>} */
  cartIsEmpty: (_, getters) => !getters.getPreparedItems.length,

  /** @type {import('../../../store').VuexGetter<QueryByCartItemId<CartItem>>} */
  getCartItem:    state => orderItemId => state.cartContent[orderItemId],
  /** @type {import('../../../store').VuexGetter<QueryByCartItemId<number>>} */
  orderItemPrice: (_, getters) => (orderItemId) => {
    /** @type {CartItem} */
    const orderItem = getters.getCartItem(orderItemId);

    if (orderItem && orderItem.data) {
      return getters.calculateTotalPriceForProductTemplate(orderItem.data);
    }

    return 0;
  },
  orderTotalPrice: (state, getters) => {
    let price = 0;

    Object.keys(state.cartContent).forEach((orderItemId) => {
      price += (
        getters.orderItemPrice(orderItemId) *
        state.cartContent[orderItemId].quantity
      );
    });

    return price;
  },
  cartCompleted: (state, getters) => getters.cartLength !== 0 &&
    getters.orderItemCompleted,

  getPreparedItems: (state, getters) => Object.entries(getters.cart)
    .map(([ orderItemId, orderItem ]) => {
      const formattedOrderItems = [];

      Object.values(orderItem.data)
        .forEach((category) => {
          Object.entries(category).forEach(([ itemId, item ]) => {
            if (itemId !== 'radio') {
              formattedOrderItems.push({
                menu_item_id: parseInt(itemId, 10),
                quantity:     item.quantity,
                modifier:     item.modifier,
              });
            }
          });
        });

      return {
        id:              orderItemId,
        menu_product_id: orderItem.productKey,
        price:           getters.orderItemPrice(orderItemId)
          .toFixed(2)
          .toString(),
        quantity:    orderItem.quantity,
        composition: formattedOrderItems,
      };
    }),
  getMainItemsFromOrderItem: (_, getters) => orderItem =>
    getters.makeOrderItemFlat(orderItem)
      .filter(item => !getters.isBundleItem(item.key)),
  getBundleItemsFromOrderItem: (_, getters) => orderItem =>
    getters.makeOrderItemFlat(orderItem)
      .filter(item => getters.isBundleItem(item.key)),
  /*
    This check is needed to understand whether the order has a bundle from the business logic perspective.
    In the current implementation, order item includes items that represent the bundle as empty, even though these items are considered to be "bundle items".
    e.g: order has 'no bundle' item, that is in "bundle category". Therefore it has bundle items in the order, but in reality, the bundle is non-existent.
    TODO: this behavior should probably be refactored since it is a huge overhead.
   */
  doesOrderIncludeBundle: (_, getters) => orderItem =>
    !getters.getBundleItemsFromOrderItem(orderItem)
      .map(item => item.name.toLowerCase())
      .includes('no fries'),
  /** The partial bundle is a bundle that only has fries (with or without sauce), but no drink. */
  doesOrderIncludePartialBundle: (_, getters) => orderItem =>
    getters.doesOrderIncludeBundle(orderItem) &&
    getters.getBundleItemsFromOrderItem(orderItem)
      .map(item => item.name.toLowerCase())
      .includes('no bundle'),
};

export default {
  state,
  getters,
};



// WEBPACK FOOTER //
// ./src/apps/cart/store/state.js